import createForEach from './internals/createForEach.js';

var forEach = createForEach(1);

export { forEach as default };
